var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.702,
    height: 31.511,
    viewBox: "0 0 31.702 31.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook",
    "data-name": "Icon awesome-facebook",
    d: "M32.265,16.414A15.851,15.851,0,1,0,13.937,32.073V21H9.91V16.414h4.027V12.921c0-3.972,2.365-6.167,5.987-6.167a24.394,24.394,0,0,1,3.549.309v3.9h-2a2.291,2.291,0,0,0-2.583,2.475v2.975h4.4L22.583,21H18.89V32.073A15.857,15.857,0,0,0,32.265,16.414Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.34b32297d718c5a75d1330a0517c89fa.svg";
export { ForwardRef as ReactComponent };